import type { IconType } from 'react-icons'
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa6'
import { SOCIAL_LINKS, type SocialName } from '@/constants/social'
import { cn } from '@/lib/cn'

const icons: Record<SocialName, IconType> = {
  Instagram: FaInstagram,
  Facebook: FaFacebookF,
  LinkedIn: FaLinkedinIn,
}

/** Instagram, Facebook and LinkedIn buttons for the dark green footer. */
export const SocialLinks = ({ className }: { className?: string }) => (
  <ul aria-label="Social media" className={cn('flex items-center gap-3', className)}>
    {SOCIAL_LINKS.map((social) => {
      const Icon = icons[social.name]
      return (
        <li key={social.name}>
          <a
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${social.name} (opens in a new tab)`}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/5 text-white/85 transition-all duration-200 hover:-translate-y-0.5 hover:border-gold-200 hover:bg-gold-200 hover:text-green-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-200 focus-visible:ring-offset-2 focus-visible:ring-offset-green-950"
          >
            <Icon aria-hidden="true" className="h-[1.05rem] w-[1.05rem]" />
          </a>
        </li>
      )
    })}
  </ul>
)
